module.exports = __webpack_public_path__ + "static/img/ibs-fm-management.2bc942e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/ibs-fm-management.jpg
// module id = iQDO
// module chunks = 0